var ko = require('knockout');

function Tooltip(params) {
  this.buttonText = params.buttonText;
  this.closeButtonText = params.closeButtonText;
  this.id = 'tooltip-' + String(new Date().getTime());
  this.text = params.text;
  this.title = params.title;

  this.isVisible = ko.observable(false);

  this.show = function() {
    this.isVisible(true);
  };

  this.hide = function() {
    this.isVisible(false);
  };
}

module.exports = Tooltip;
